export default "__VITE_ASSET__a777a717__"